import {
  collectFlowEffectsFromTemplate,
  normalizeGuideTemplateWithFlow,
  normalizeFlow,
  buildFlowFromQuestions,
  questionsFromFlow,
} from "../../../utils/guideFlow/guideFlowCore";
import { buildEdgesFromOptions } from "../../../utils/guideFlow/GuideFlowBuilder";

export function normalizeGuideTemplate(template) {
  return normalizeGuideTemplateWithFlow(template);
}

function mergeCaseGuideEffect(effects, effect) {
  const data = effect || {};
  const extraTags = Array.isArray(data.tag_ids) ? data.tag_ids : data.tag_ids ? [data.tag_ids] : [];
  effects.tag_ids = [...(effects.tag_ids || []), ...extraTags];

  ["priority", "user_assigned_id", "user_responsible_id", "due_date", "title", "title_suffix"].forEach((key) => {
    if (data[key] === undefined || data[key] === null || data[key] === "") return;
    effects[key] = data[key];
  });

  if (data.next_case_guide_template_id !== undefined && data.next_case_guide_template_id !== null && data.next_case_guide_template_id !== "") {
    const n = Number(data.next_case_guide_template_id);
    if (Number.isFinite(n) && n > 0) effects.next_case_guide_template_id = n;
  }
}

export function collectGuideEffects(template, answers) {
  return collectFlowEffectsFromTemplate(template, answers, mergeCaseGuideEffect);
}

export function buildQuestionEffects(question) {
  return asArray(question.options)
    .filter((option) => option?.value !== undefined && option?.value !== null)
    .map((option) => ({
      when_value: option.value,
      ...(option.effects || {}),
    }))
    .filter((effect) => {
      const tagIds = Array.isArray(effect.tag_ids) ? effect.tag_ids.filter(Boolean) : [];
      return (
        tagIds.length > 0 ||
        effect.priority ||
        effect.user_assigned_id ||
        effect.user_responsible_id ||
        effect.due_date ||
        effect.title ||
        effect.title_suffix ||
        effect.next_case_guide_template_id
      );
    });
}

/** Case guides: effects belong on effect-nodes only; strip legacy per-option effect payloads before save. */
function stripQuestionOptionEffectsFromFlow(flow) {
  return {
    ...flow,
    nodes: (flow.nodes || []).map((node) => {
      if ((node.type || "question") !== "question") return node;
      return {
        ...node,
        data: {
          ...(node.data || {}),
          options: asArray(node.data?.options).map((opt) => ({
            ...opt,
            effects: {},
          })),
        },
      };
    }),
  };
}

export function prepareGuideTemplateForSave(template) {
  const rawFlow = normalizeFlow(
    template.settings?.flow || buildFlowFromQuestions(template.questions || []),
    template.questions || []
  );
  const flow = stripQuestionOptionEffectsFromFlow(rawFlow);
  const questions = questionsFromFlow(flow, template.questions || []).map((question, index) => ({
    ...question,
    sort_order: question.sort_order ?? index,
    effects: buildQuestionEffects(question),
  }));
  const normalizedFlow = {
    ...flow,
    edges: buildEdgesFromOptions(flow),
  };

  return {
    ...template,
    settings: {
      ...(template.settings || {}),
      flow: normalizedFlow,
    },
    questions,
  };
}

function asArray(value) {
  return Array.isArray(value) ? value : [];
}
